import { LOAD_JOBCOINS_PACKETS, CLEAN_SELECTED_JOBCOINS_PACKET, SELECT_JOBCOINS_PACKET } from "./actionTypes";

export const loadPackets = packets => ({
    type: LOAD_JOBCOINS_PACKETS,
    packets
});

export const choosePacket = packet => ({
    type: SELECT_JOBCOINS_PACKET,
    packet
});

export const cleanPacket = () => ({
    type: CLEAN_SELECTED_JOBCOINS_PACKET
});